"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../helpers");
exports.config = {
    paddingLeft: helpers_1.SPACING_L,
    paddingRight: helpers_1.SPACING_M
};
//# sourceMappingURL=helpers.js.map